import { useEffect, useState } from 'react';

interface AttachScriptArgs {
  crossOrigin?: string;
  onLoad: () => void;
  src: string;
}

const attachScript = ({ crossOrigin, onLoad, src }: AttachScriptArgs) => {
  const existingScript = document.querySelector<HTMLScriptElement>(
    `script[src="${src}"]`
  );
  const script = existingScript ?? document.createElement('script');
  script.addEventListener('load', onLoad);

  if (!existingScript) {
    script.src = src;
    if (crossOrigin) script.crossOrigin = crossOrigin;
    script.async = true;
    document.body.appendChild(script);
  }

  return () => script.removeEventListener('load', onLoad);
};

interface UseScriptOptions {
  crossOrigin?: string;
  isReady: () => boolean;
}

export const useScript = (
  src: string,
  { crossOrigin, isReady }: UseScriptOptions
) => {
  const [isLoaded, setIsLoaded] = useState(isReady);

  useEffect(() => {
    if (isLoaded) return undefined;
    return attachScript({
      crossOrigin,
      onLoad: () => setIsLoaded(isReady()),
      src,
    });
  }, [crossOrigin, isLoaded, isReady, src]);

  return isLoaded;
};
